import { combineReducers } from 'redux';

import company from './company';
import user from './user';

export default combineReducers({ company, user });
